export const DATE_PICKER_YEAR_DROPDOWN_ITEM_NUMBER = 50;
